import { ReactElement } from 'react';

import { Select } from '@dreryk/react-components';
import { FormContextValues, useTranslate } from '@dreryk/react-common';

import { patientMedicalInformationTranslationKeys } from '../../translations';

import {
   MedicalInformationAttachmentMarkAsRemovedFormBean,
   MedicalInformationAttachmentMarkAsRemovedReason,
} from './MedicalInformationAttachmentMarkAsRemovedForm.types';

const ITEMS: MedicalInformationAttachmentMarkAsRemovedReason[] = ['MISTAKE', 'OTHER'];

export const MedicalInformationAttachmentMarkAsRemovedFormReasonField = (
   props: Pick<FormContextValues<MedicalInformationAttachmentMarkAsRemovedFormBean>, 'register'>
): ReactElement => {
   const translate = useTranslate();
   return (
      <Select<MedicalInformationAttachmentMarkAsRemovedReason>
         triggerLabelExtractor={(item) =>
            translate(patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.reason[item])
         }
         label={patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.reason.label}
         controller={props.register('reason')}
         testId={'reason'}
      >
         <Select.List items={ITEMS}>
            {(item: MedicalInformationAttachmentMarkAsRemovedReason) => (
               <Select.Item<MedicalInformationAttachmentMarkAsRemovedReason>
                  item={item}
                  testId={item}
                  label={
                     patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.reason[item]
                  }
               />
            )}
         </Select.List>
      </Select>
   );
};
